import styled from 'styled-components';
import { StaticImg } from '../../ui';
import { HALF_CONTRAST, CONTRAST } from '../../theme';

export const Header = styled.h3`
  margin: 0 0 8px 0;
  font-weight: 500;
  font-size: 18px;
  color: ${CONTRAST};
`;
export const Subheader = styled.h4`
  margin: 0 0 8px 0;
  font-weight: 500;
  font-size: 16px;
  color: ${CONTRAST};
`;
export const Paragraph = styled.p`
  margin: 0 0 12px 0;
  font-size: 14px;
  color: ${HALF_CONTRAST};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  &:nth-child(even) {
    background: #efefef;
  }
  padding-top: 2px;
  padding-bottom: 2px;
  position: relative;
`;
export const RowWhite = styled.div`
  display: flex;
  /* page-break-before: always; */
  flex-direction: row;
  padding-top: 2px;
  padding-bottom: 2px;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 16px;
`;

const COLUMN_PADDING = '0 4px';
export const ColumnHalf = styled.div`
  page-break-inside: avoid;
  flex-direction: column;
  flex: 2;
  padding: ${COLUMN_PADDING};
  box-sizing: border-box;
  display: flex;
`;

export const ColumnHalfCentered = styled.div`
  flex: 2;
  text-align: center;
`;

export const Heading = styled.h4`
  color: ${CONTRAST};
  padding: 0 0 16px 0;
  margin: 0;
  font-size: 18px;
  line-height: 24px;
  font-weight: bold;
`;

export const AddressLine1 = styled.h3`
  color: ${CONTRAST};
  padding: 0;
  margin: 0;
  font-size: 18px;
  line-height: 24px;
  font-weight: bold;
`;

export const Key = styled.div`
  flex: 1;
  font-size: 14px;
  color: ${HALF_CONTRAST};
  line-height: 24px;
  padding: ${COLUMN_PADDING};
  margin: 0;
`;

export const Value = styled.div`
  font-size: 14px;
  flex: 1;
  line-height: 24px;
  padding: ${COLUMN_PADDING};
  margin: 0;
`;

export const GraphWrapper = styled.div`
  width: 100%;
  height: 320px;
`;

export const MapImg = styled.img`
  width: 100%;
`;

export const Container = styled.div`
  padding: 16px;
  padding-bottom: 70px;
`;
export const BottomRow = styled.div`
  display: block;
  padding-top: 16px;
  width: 100%;
  text-align: center;
`;
export const Logo = styled(StaticImg)`
  width: 180px;
  padding-right: 8px;
`;
export const FullWidth = styled.div`
  width: 100%;
`;
export const Spacer = styled.div`
  width: 12px;
`;
export const SectionTitle = styled.h3`
  padding: 6px 0 6px 0;
  display: inline-block;
  color: ${CONTRAST};
`;
export const Subtitle = styled.h4`
  padding: 0;
  display: inline-block;
  font-size: 16px;
  color: ${HALF_CONTRAST};
`;
export const FieldTitle = styled.span`
  color: ${HALF_CONTRAST};
`;
export const MapLegend = styled.div``;
export const Square = styled.div`
  height: 12px;
  width: 12px;
  margin-top: 2px;
  margin-right: 4px;
  margin-left: 8px;
  margin-bottom: 8px;
  border: 1px solid ${({ color }) => color};
  border-radius: 3px;
  &:first-of-type {
    margin-left: 0;
  }
`;

export const Title = styled.div`
  padding-bottom: 4px;
  font-weight: bold;
  font-size: 16px;
  padding-top: 16px;
`;
